// Import all page components
import OrderBookPage from "../pages/OrderBookPage/OrderBookPage";
import PositionBookPage from "../pages/PositionBookPage/PositionBookPage";
import HoldingBookPage from "../pages/HoldingBookPage/HoldingBookPage";
import SettingsPage from "../pages/SettingsPage/SettingsPage";
import OrderInitiatePage from "../pages/OrderInitiatePage/OrderInitiatePage";
import OrderStatusPage from "../pages/OrderStatusPage/OrderStatusPage";
import FundsPage from "../pages/FundsPage/FundsPage";
import ClientHealthPage from "../pages/ClientHealthPage/ClientHealthPage";

// Used by AppRoutes and Sidebar to stay in sync
export const routesConfig = [
  {
    path: "/order-book",
    component: OrderBookPage,
    label: "Order Book",
    alt: "Order Book",
    iconName: "OrderBookIcon",
    roles: ["MASTER", "TRADER"],
    showInSidebar: true,
  },
  {
    path: "/order-initiate",
    component: OrderInitiatePage,
    label: "Order Initiate",
    alt: "Order Initiate",
    iconName: "AddIcon",
    roles: ["MASTER", "TRADER"],
    showInSidebar: true,
  },
  {
    path: "/position-book",
    component: PositionBookPage,
    label: "Position Book",
    alt: "Position Book",
    iconName: "PositionBookIcon",
    roles: ["MASTER", "TRADER"],
    showInSidebar: true,
  },
  {
    path: "/holding-book",
    component: HoldingBookPage,
    label: "Holding Book",
    alt: "Holding Book",
    iconName: "HoldingBookIcon",
    roles: ["MASTER", "TRADER"],
    showInSidebar: true,
  },
  {
    path: "/order-status",
    component: OrderStatusPage,
    label: "Order Status",
    alt: "Order Status",
    roles: ["MASTER", "TRADER"],
    showInSidebar: false,
  },
  {
    path: "/funds",
    component: FundsPage,
    label: "Funds",
    alt: "Funds",
    iconName: "FundsIcon",
    roles: ["MASTER", "TRADER"],
    showInSidebar: false,
  },
  {
    path: "/client-health",
    component: ClientHealthPage,
    label: "Client Health",
    alt: "Client Health",
    iconName: "ClientHealthIcon",
    roles: ["MASTER", "TRADER"],
    showInSidebar: true,
  },
  {
    path: "/settings",
    component: SettingsPage,
    label: "Settings",
    alt: "Settings",
    iconName: "SettingsIcon",
    roles: ["MASTER", "TRADER"],
    showInSidebar: true,
  },
];

export const getRoutableRoutes = () => {
  return routesConfig.filter((route) => route.component !== null);
};

export const getSidebarRoutes = () => {
  return routesConfig.filter((route) => route.showInSidebar === true);
};
